import { addBox, updateBoxTimeline } from "../../common/actions";

/**
 * Drop a backend-built MotionScene box onto a scene.
 *
 * The backend (motionize, logo intro) returns `{ boxId, box, toolbar }` for a
 * full-bleed MotionScene: the scene is one self-contained document in blob
 * storage, so there is nothing to lay out here — add the box and give it the
 * timeline length the document runs for.
 *
 * @returns {string|null} the box id, or null when the result had no box.
 */
export function addMotionSceneBox(dispatch, result, fallbackNavId) {
  if (!result?.box || !result?.toolbar) return null;
  const { box, toolbar } = result;
  const targetNavId = box.parent || fallbackNavId;
  const boxId = result.boxId || box.id;
  dispatch(
    addBox(
      { id: boxId, parent: targetNavId, container: 0 },
      false,
      false,
      "",
      toolbar.style || {},
      toolbar.state || {},
      toolbar.structure,
      {
        name: toolbar.pluginId,
        position: { x: "0%", y: "0%", type: "absolute" },
        // "100%" as a STRING, not 100 with a separate unit. The
        // ADD_BOX reducer rebuilds structure from these and never
        // reads widthUnit/heightUnit: it decides the height unit
        // from `resizable` ("%" when true, "px" when false) and
        // only overrides it if the height STRING contains "%".
        // This box is deliberately not resizable, so a numeric
        // 100 was being stored as 100px — a fixed strip instead
        // of a full-bleed scene.
        width: "100%",
        height: "100%",
      }
    )
  );
  if (box.timeline) dispatch(updateBoxTimeline(boxId, box.timeline));
  return boxId;
}
